// extracted by mini-css-extract-plugin
export default {"circle":"Cursor_circle__uWz-I","clickable":"Cursor_clickable__fREwY","speak":"Cursor_speak__4tgCz","all":"Cursor_all__fS6LD"};